import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M21 12h-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 6H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 18h-8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 6v4c0 1.1.9 2 2 2h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 10v6c0 1.1.9 2 2 2h3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListTree";
const ListTree = memo(themed(Icon));
export {
  ListTree
};
//# sourceMappingURL=list-tree.js.map
